import { Component, Input } from '@angular/core';

/**
 * Card contenedora para agrupar varios `app-detail-row`.
 *
 * Antes de este componente, cada pantalla que necesitaba una lista de
 * `app-detail-row` (radio, sombra, padding y `display: block` por fila)
 * lo reimplementaba a mano. Este componente centraliza ese shell y deja el
 * contenido a `<ng-content>`, así sirve tanto para un bloque encabezado por
 * `app-entity-header` como para una card con intro + filas.
 */
@Component({
    selector: 'app-detail-card',
    templateUrl: './detail-card.component.html',
    styleUrls: ['./detail-card.component.scss'],
    standalone: false
})
export class DetailCardComponent {
    /** Agrega una línea divisoria entre `app-detail-row` consecutivos. */
    @Input() dividers = false;
}
